<template>
  <div>
    <vue-date-picker
        ref="datePicker"
        v-model="tmpValidFrom"
        :min-date="minDate"
        :max-date="maxDate"
        :dark="!!isDarkTheme"
        :format="'yyyy-MM-dd'"
        placeholder="Data de start a asigurarii"
        @update:model-value="onValidFromChange"
        :enable-time-picker="false"
        locale="ro"
        :clearable="false"
        :disable-year-select="true"
        text-input
        :auto-apply="true"
        :hide-input-icon="true"
        class="hidden-date-picker"
    >
      <template #trigger>
        <v-text-field
            rounded="lg"
            variant="outlined"
            :tile="true"
            v-model="formattedDate"
            label="Data de start a asigurarii de calatorie"
            class="cursor-pointer"
            readonly
            bg-color="surface"
        >
        </v-text-field>
      </template>
    </vue-date-picker>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted} from 'vue';
import {useNuxtApp} from '#app';
import { useTheme } from 'vuetify';

export default defineComponent({
  props: {
    modelValue: {
      type: [String, null],
      default: null,
    },
  },
  //TODO ADD VALIDATION ERROR BORDER RED
  setup(props, {emit}) {
    const {$dayjs} = useNuxtApp();
    const validFrom = ref<string | null>(props.modelValue);
    const tmpValidFrom = ref<Date | string | null>(validFrom.value);
    const formattedDate = ref<string | null>(validFrom.value ? $dayjs(validFrom.value).format('YYYY-MM-DD') : null);
    const datePicker = ref(null);
    const theme = useTheme();
    const isDarkTheme = computed(() => theme.global.current.value.dark);


    const computeDates = () => {
      const now = $dayjs();
      const minDate = now.add(1, 'day').format('YYYY-MM-DD');
      const maxDate = now.add(60, 'days').format('YYYY-MM-DD');
      return {minDate, maxDate};
    };

    const {minDate, maxDate} = computeDates();

    const onValidFromChange = (newValue: string) => {
      validFrom.value = $dayjs(newValue).format('YYYY-MM-DD');
      formattedDate.value = validFrom.value;
      emit('update:modelValue', validFrom.value);
    };

    watch(tmpValidFrom, (newValue) => {
      if (newValue) {
        emit('update:modelValue', $dayjs(newValue).format('YYYY-MM-DD'));
      }
    });

    watch(() => props.modelValue, (newValue) => {
      if (newValue) {
        const today = $dayjs().format('YYYY-MM-DD');
        const formatted = $dayjs(newValue).format('YYYY-MM-DD');

        if (formatted <= today) {
          validFrom.value = null;
          tmpValidFrom.value = null;
          formattedDate.value = null;
          emit('update:modelValue', null); // Reset modelValue to null
          return;
        }

        if (formatted !== validFrom.value) {
          validFrom.value = formatted;
          tmpValidFrom.value = formatted;
          formattedDate.value = formatted;
        }
      } else {
        validFrom.value = null;
        tmpValidFrom.value = null;
        formattedDate.value = null;
      }
    });

    onMounted(() => {
      const defaultDate = $dayjs().add(1, 'day').format('YYYY-MM-DD');
      validFrom.value = defaultDate;
      tmpValidFrom.value = defaultDate;
      formattedDate.value = defaultDate;
      emit('update:modelValue', defaultDate);
    });

    return {
      validFrom,
      minDate,
      maxDate,
      onValidFromChange,
      tmpValidFrom,
      formattedDate,
      datePicker,
      isDarkTheme,
    };
  },
});
</script>

<style>

</style>
